import { Stack } from "@mui/material";
import React from "react";
import useViewOnOpen from "../../Hooks/useViewOnOpen";
import { StackContainerDirection } from "../../Models/StackContainerDirection";
import { StackContainerModel } from "../../Models/StackContainerModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

type StackContainerComponentProps = IComponentProps<StackContainerModel>;

const StackContainerComponent: React.FC<StackContainerComponentProps> = ({ component, context }) => {
  const spacing = component.Spacing ?? 2;
  const direction = component.Direction === StackContainerDirection.Column ? "column" : "row";

  const componentLayoutSx = getComponentLayout(component);

  useViewOnOpen(component, context, "StackContainerComponent");

  return (
    <Stack direction={direction} spacing={spacing} overflow="auto" sx={componentLayoutSx}>
      {component.Children.map((child) => (
        <ComponentFactory key={child.Id} parent={component} component={child} context={context} />
      ))}
    </Stack>
  );
};

export default StackContainerComponent;
